var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import UtilsMixin from '@/mixins/utils-mixin';
import { ContractManagementService } from '@/services/contract-management/contract-management-service';
import { VendorService } from '@/services/vendor-service';
import { MaterialService } from '@/services/material-management/material-service';
import * as uuid_v4 from 'uuid/v4';
var VendorMaterialAssociationsCrudSidesheet = /** @class */ (function (_super) {
    __extends(VendorMaterialAssociationsCrudSidesheet, _super);
    function VendorMaterialAssociationsCrudSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataLoaded = false;
        _this.options = {
            vendors: [],
            materials: [],
        };
        return _this;
    }
    VendorMaterialAssociationsCrudSidesheet.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validationRules = this.contractManagementService.getValidationRules();
                        this.dataLoaded = false;
                        return [4 /*yield*/, this.lazyLoadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VendorMaterialAssociationsCrudSidesheet.prototype.lazyLoadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // if we have already loaded the data, don't load again
                        if (this.dataLoaded) {
                            return [2 /*return*/];
                        }
                        _a = this.options;
                        return [4 /*yield*/, this.vendorService.getAllRef()];
                    case 1:
                        _a.vendors = (_c.sent()).data.filter(function (item) { return item.vendorType === 'C'; });
                        _b = this.options;
                        return [4 /*yield*/, this.materialService.getAll(false)];
                    case 2:
                        _b.materials = (_c.sent()).data.filter(function (item) { return item.materialGroupId.length > 0; });
                        this.dataLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    VendorMaterialAssociationsCrudSidesheet.prototype.creating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vendorMaterial_1, contract, matchingVendorMaterial, doesVendorExist, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        vendorMaterial_1 = __assign({}, this.selectedItem);
                        contract = __assign({}, this.item);
                        matchingVendorMaterial = contract.vendorMaterials
                            .filter(function (vm) {
                            return vm.vendorId === vendorMaterial_1.vendorId &&
                                vm.materialId === vendorMaterial_1.materialId;
                        });
                        if (matchingVendorMaterial.length > 0) {
                            // show an error to the user, and do not update local collection
                            this.showSnackbar({
                                text: 'Vendor <strong>' + vendorMaterial_1.vendorId + '</strong> and material <strong>' + vendorMaterial_1.materialId + '</strong> already exist with this contract',
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.contractManagementService.doesVendorMaterialExistWithDates(vendorMaterial_1.vendorId, vendorMaterial_1.materialId, contract.startDate, contract.endDate)];
                    case 1:
                        doesVendorExist = _a.sent();
                        if (doesVendorExist) {
                            // show an error to the user, and do not update local collection
                            this.showSnackbar({
                                text: 'Vendor <strong>' + vendorMaterial_1.vendorId + '</strong> and material <strong>' + vendorMaterial_1.materialId + '</strong> already exist with an Active contract',
                                color: 'error',
                            });
                            return [2 /*return*/];
                        }
                        // update local collection
                        vendorMaterial_1.contractVendorMaterialXrefId = this.getUniqueId();
                        vendorMaterial_1.vendorName = this.options.vendors.filter(function (v) { return v.vendorId === vendorMaterial_1.vendorId; })[0].vendorName;
                        vendorMaterial_1.materialDescription = this.options.materials.filter(function (m) { return m.materialId === vendorMaterial_1.materialId; })[0].materialDesc;
                        return [4 /*yield*/, this.updateItems(vendorMaterial_1)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({
                            text: 'Unable to save vendor / material',
                            color: 'error',
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VendorMaterialAssociationsCrudSidesheet.prototype.updateItems = function (item) {
        if (item === void 0) { item = null; }
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                try {
                    if (item === null) {
                        item = __assign({}, this.selectedItem);
                    }
                    contract = __assign({}, this.item);
                    // locally update collection
                    contract.vendorMaterials = this.updateItemsCollection(contract.vendorMaterials, item, ['contractVendorMaterialXrefId', 'contractId']);
                    // update item we are looking at
                    this.item = contract;
                    // close the side sheet
                    this.close();
                    this.showSnackbar({
                        text: 'Vendor / material has been saved locally.<br />You must SUBMIT the contract in order for your changes to take effect.',
                        color: 'success',
                    });
                }
                catch (error) {
                    console.error(error);
                    this.showSnackbar({
                        text: 'Unable to save vendor / material',
                        color: 'error',
                    });
                }
                finally {
                    this.sidesheetLoading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    VendorMaterialAssociationsCrudSidesheet.prototype.getUniqueId = function () {
        return uuid_v4();
    };
    VendorMaterialAssociationsCrudSidesheet.prototype.onStepChanged = function (val, oldVal) {
        if (val && val !== oldVal && val === 'VA') {
            this.lazyLoadData();
        }
    };
    var _a, _b, _c;
    __decorate([
        lazyInject(TYPES.ContractManagementService),
        __metadata("design:type", typeof (_a = typeof ContractManagementService !== "undefined" && ContractManagementService) === "function" ? _a : Object)
    ], VendorMaterialAssociationsCrudSidesheet.prototype, "contractManagementService", void 0);
    __decorate([
        lazyInject(TYPES.VendorService),
        __metadata("design:type", typeof (_b = typeof VendorService !== "undefined" && VendorService) === "function" ? _b : Object)
    ], VendorMaterialAssociationsCrudSidesheet.prototype, "vendorService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialService),
        __metadata("design:type", typeof (_c = typeof MaterialService !== "undefined" && MaterialService) === "function" ? _c : Object)
    ], VendorMaterialAssociationsCrudSidesheet.prototype, "materialService", void 0);
    __decorate([
        Watch('step', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], VendorMaterialAssociationsCrudSidesheet.prototype, "onStepChanged", null);
    VendorMaterialAssociationsCrudSidesheet = __decorate([
        Component({
            components: {
                'base-crud-sidesheet': BaseCrudSidesheet,
            },
        })
    ], VendorMaterialAssociationsCrudSidesheet);
    return VendorMaterialAssociationsCrudSidesheet;
}(Mixins(CrudSidesheetMixin, SteppedPageMixin, SnackbarMixin, UtilsMixin)));
export default VendorMaterialAssociationsCrudSidesheet;
